import { FailureView } from "./FailureView.tsx";
import { exceptionPage } from "./style.css.ts";

/**
 * A minimal error page. Note that it must not contain any components that
 * depend on appkit config etc... as it will be rendered at the very root
 * without any providers.
 */
export function ExceptionPage() {
  return (
    <div className={exceptionPage.container}>
      <FailureView failure={{ type: "UNKNOWN_ERROR" }} />
    </div>
  );
}
